import { render } from "./Home.vue?vue&type=template&id=30f5d9f4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=30f5d9f4&scoped=true&lang=scss"

import exportComponent from "/home/prof1/projects/intercom_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f5d9f4"]])

export default __exports__